import styles from './EventsSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ImageHeadingDate from '../../components/ImageHeadingDate/ImageHeadingDate';
import { CiCalendarDate } from 'react-icons/ci';
import EventImg from '../../assets/images/Photo.png';
import { NavLink } from 'react-router';

export const EventsSection = () => {
  const eventList = [
    {
      image: EventImg,
      heading: 'Inter-school Competition',
      date: 'Jan 31 , 5:00 to 6:00pm',
    },
    {
      image: EventImg,
      heading: 'Sports Event',
      date: 'Jan 31 , 5:00 to 6:00pm',
    },
    {
      image: EventImg,
      heading: 'Science Fair',
      date: 'Jan 31 , 5:00 to 6:00pm',
    },
    {
      image: EventImg,
      heading: 'Inter-school Competition',
      date: 'Jan 31 , 5:00 to 6:00pm',
    },
    {
      image: EventImg,
      heading: 'Inter-school Competition',
      date: 'Jan 31 , 5:00 to 6:00pm',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<CiCalendarDate />} heading="Events" />
        <NavLink className={styles.viewAll} to={'calender/schoolcalender'}>
          View All
        </NavLink>
      </div>

      <div className={styles.list}>
        {eventList.map((event, index) => (
          <ImageHeadingDate key={index} {...event} />
        ))}
      </div>
    </div>
  );
};
